<section class="rental-item-container mb-4">
  <common-validation-card
    *ngIf="fulfillmentItem.statusData.bannerIcon && fulfillmentItem.statusData.bannerMessage"
    [messages]="[fulfillmentItem.statusData.bannerMessage]"
    [iconClass]="fulfillmentItem.statusData.bannerIcon"
    cardClass="bg-grey bb-0"
  ></common-validation-card>
  <div class="d-flex align-items-center mb-3" [ngClass]="{ 'mt-4': fulfillmentItem.statusData.bannerIcon && fulfillmentItem.statusData.bannerMessage }">
    <app-thumbnail-with-x height="100px" width="100px" borderRadius="5px" [imgSrc]="fulfillmentItem.coverPhoto" [hideX]="true"> </app-thumbnail-with-x>
    <div class="ml-4">
      <label>
        <span class="section-header bold">{{ fulfillmentItem.make }}</span> {{ fulfillmentItem.model }}
      </label>
      <div>{{ fulfillmentItem.year }} {{ fulfillmentItem.primaryType }}</div>
      <div class="mt-2 text-grey paragraph-text">{{ fulfillmentItem?.rentalItemState?.inventoryItem.serialNumber || "Serial Number" }}</div>
    </div>
    <div class="ml-5 d-none d-md-block">
      <label>Est. Job Duration</label>
      <div class="paragraph-text">{{ fulfillmentItem.jobStartDate | date: "shortDate" }} - {{ fulfillmentItem.jobEndDate | date: "shortDate" }}</div>
      <div class="text-grey paragraph-text mt-2">({{ fulfillmentItem.duration }})</div>
    </div>
    <div class="ml-auto d-none d-md-block">
      <a class="d-flex align-items-center paragraph-text" [routerLink]="['item', fulfillmentItem.inventoryId, 'transportation']"
        >View <i class="icon-arrow-right ml-1 text-green"></i
      ></a>
    </div>
  </div>

  <div class="d-flex d-md-none mt-3 mb-1">
    <div class="mr-1">
      <common-status-label [status]="fulfillmentItem.statusData.status" labelStyle="status-pill"></common-status-label>
    </div>
    <div class="ml-4">
      <label>Est. Job Duration</label>
      <div class="paragraph-text">{{ fulfillmentItem.jobStartDate | date: "shortDate" }} - {{ fulfillmentItem.jobEndDate | date: "shortDate" }}</div>
      <div class="text-grey paragraph-text mt-2">({{ fulfillmentItem.duration }})</div>
    </div>
  </div>
  <!-- tablet and desktop status and start return -->
  <div class="d-none d-md-flex">
    <div>
      <common-status-label [status]="fulfillmentItem.statusData.status" labelStyle="status-pill"></common-status-label>
    </div>
  </div>
  <!--  mobile
     view details button -->
  <div class="d-md-none mt-3">
    <common-icon-button-secondary
      iconClass="icon-eyeball"
      buttonText="View details"
      [routerLink]="['item', fulfillmentItem.inventoryId, 'transportation']"
    ></common-icon-button-secondary>
  </div>
</section>
